import type { PaletteKey } from '../palette';

type Recolor = Partial<Record<PaletteKey, PaletteKey>>;

/**
 * Hat palettes (the lobby ADR): a hat recolours the straw of the gardener's sun hat, the art's `y Y U e t` pixels.
 * `drawGardener` applies it to the hat alone (each part is recoloured on its own, ADR-0073), so a look may use these
 * colours too. Keyed like content `HATS` (packages/content/src/hats.ts); assets may not import content, so the keys are
 * duplicated here: keep them in sync (a client test checks). `straw` is the art as drawn, and so is headwear of its own
 * (`HEADWEAR` in headwear.ts, ADR-0089: the conical hat, the durag, the turban) and a set's head (`SET_ART`, ADR-0112,
 * ADR-0160).
 */
export const HAT_PALETTES = {
  straw: {},
  mint: { y: 'l', Y: 'g', U: 'G', e: 'y', t: 'g' },
  lavender: { y: 'i', Y: 'p', U: 'P', e: 'w', t: 'p' },
  midnight: { y: '4', Y: '3', U: '2', e: '5', t: '3' },
  golden: { y: 'w', Y: 'y', U: 'Y', e: 'w', t: 'y' },
  conical: {},
  durag: {},
  turban: {},
  gnome: {},
  beekeeper: {},
  astronaut: {},
  pumpkin: {},
  reaper: {},
  creator: {},
  inferno: {},
  kitsune: {},
  voidwalker: {},
  tempest: {},
  glacier: {},
  angler: {},
  jester: {},
  plague: {},
  chronomancer: {},
  glitch: {},
  disco: {},
  origami: {},
  ooze: {},
  barnstormer: {},
  pirate: {},
  magician: {},
  chef: {},
  knight: {},
  sheriff: {},
  luchador: {},
} as const satisfies Record<string, Recolor>;
